/*
 *             Copyright (c) 2016 - 2022, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
var _0xe8ca=['enableCommand','editor','get','plugins','requires','input','init','TrackChangesEditing'];(function(_0x546c04,_0xe8ca1a){var _0x4fc63a=function(_0x4d0f42){while(--_0x4d0f42){_0x546c04['push'](_0x546c04['shift']());}};_0x4fc63a(++_0xe8ca1a);}(_0xe8ca,0x1c6));var _0x4fc6=function(_0x546c04,_0xe8ca1a){_0x546c04=_0x546c04-0x0;var _0x4fc63a=_0xe8ca[_0x546c04];return _0x4fc63a;};import{Plugin as _0x56353e}from'ckeditor5/src/core';import{Input as _0x4016c1}from'ckeditor5/src/typing';export default class Z extends _0x56353e{static get[_0x4fc6('0x6')](){return[_0x4016c1];}[_0x4fc6('0x0')](){this[_0x4fc6('0x3')][_0x4fc6('0x5')][_0x4fc6('0x4')](_0x4fc6('0x1'))[_0x4fc6('0x2')](_0x4fc6('0x7'));}}